import {util} from "vue";

export default {
    data() {
        return {
            items: [],
            current: -1,
            query: '',
            minChars: 0
        }
    },

    methods: {
        update() {
            if (!this.sanitizedQuery) {
                return this.reset()
            }

            if (this.sanitizedQuery.length < this.minChars) {
                return
            }

            if (this.sanitizedQuery) {
                this.fetch();
                this.current = -1;
            }
        },

        reset () {
            this.items = [];
            this.query = '';
            this.current = -1;
        },

        activeClass (index) {
            return {
                active: this.current === index
            }
        },

        hit (event) {
            if (this.current !== -1) {
                this.onHit(event, this.items[this.current]);
            }
        },

        up () {
            if (this.current > 0) {
                this.current--;
            } else if (this.current === -1) {
                this.current = this.items.length - 1;
            } else {
                this.current = -1;
            }
        },

        down () {
            if (this.current < this.items.length - 1) {
                this.current++;
            } else {
                this.current = -1;
            }
        },

        onHit () {
            util.warn('You need to implement the `onHit` method', this);
        },

        setActive (index) {
            this.current = index;
        }
    },

    computed: {
        hasItems() {
            return this.items.length > 0;
        },

        isEmpty() {
            return !this.query;
        },

        isDirty() {
            return !this.isEmpty;
        },

        noResults() {
            return !this.hasItems && this.isDirty;
        },

        sanitizedQuery() {
            return this.query.trim();
        }
    }
}